module.exports = __webpack_public_path__ + "media/assets/images/flags/ci-1da689a9c8c52a6833bc22e5be8e3c65.svg";